import React, { Component } from "react";
import { PageHeader, message, Popconfirm, Tooltip, Tag, Row, Col } from "antd";
import { EditOutlined, StopOutlined, CheckCircleOutlined, PlusOutlined, ArrowUpOutlined, ArrowDownOutlined, DeleteOutlined, InfoCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ButtonItem, InputItem, DynamicCardForm, MensajeError } from "../../../../Components/Items";
import BotonAyudaManuales from "../../../../Components/BotonAyudaManuales";
import TabbedDynamicTable from "../../../../Components/TabbedDynamicTable";
import ModalCampoOrdenProduccionPU from "./ModalCampoOrdenProduccionPU/ModalCampoOrdenProduccionPU";
import { TIPOS_CAMPO, ENTIDADES_REFERENCIA, etiquetaDe, slugifyCampoKey } from "./camposOrdenProduccion.utils";
import FlujosProduccionPU from "../FlujosProduccionPU/FlujosProduccionPU";
import CodigosTiempoMuertoPU from "../TiemposMuertosPU/CodigosTiempoMuertoPU";

class ConfiguracionOrdenesDeProduccionPU extends Component {
  state = {
    loadingCampos: false,
    secciones: [],
    nuevaSeccionNombre: "",

    modalCampoVisible: false,
    seccionIndexActiva: null,
    campoActivo: null,
  };

  componentDidMount() {
    this.cargarConfiguracionCampos();
  }

  cargarConfiguracionCampos = () => {
    this.setState({ loadingCampos: true });
    axios
      .post("configuracionCamposOrdenProduccionPU/obtenerConfiguracion", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loadingCampos: false });
        if (res.data.success === 2) {
          this.setState({ secciones: res.data.configuracion.secciones || [] });
        } else {
          MensajeError({ message: res.data.error || "Error al cargar la configuración de campos" });
        }
      })
      .catch(() => {
        this.setState({ loadingCampos: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  guardarSecciones = (secciones) => {
    this.setState({ loadingCampos: true });
    axios
      .post(
        "configuracionCamposOrdenProduccionPU/guardarConfiguracion",
        { empresaId: this.props.empresaId, secciones },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loadingCampos: false });
        if (res.data.success === 2) {
          this.setState({ secciones: res.data.configuracion.secciones || [] });
          message.success("Configuración guardada correctamente");
        } else {
          MensajeError({ message: res.data.error || "No se pudo guardar la configuración" });
          this.cargarConfiguracionCampos();
        }
      })
      .catch(() => {
        this.setState({ loadingCampos: false });
        MensajeError({ message: "Error al conectar con el servidor" });
        this.cargarConfiguracionCampos();
      });
  };

  agregarSeccion = () => {
    if (!this.state.nuevaSeccionNombre.trim()) return;
    const secciones = [
      ...this.state.secciones,
      { nombre: this.state.nuevaSeccionNombre.trim(), orden: this.state.secciones.length + 1, campos: [] },
    ];
    this.setState({ nuevaSeccionNombre: "" });
    this.guardarSecciones(secciones);
  };

  abrirModalCampo = (seccionIndex, campo = null) => {
    this.setState({ modalCampoVisible: true, seccionIndexActiva: seccionIndex, campoActivo: campo });
  };

  cerrarModalCampo = () => {
    this.setState({ modalCampoVisible: false, seccionIndexActiva: null, campoActivo: null });
  };

  guardarCampo = (campoFinal) => {
    const keysExistentes = new Set(this.state.secciones.flatMap((s) => s.campos.map((c) => c.key)));
    const esNuevo = !this.state.campoActivo;

    if (esNuevo && !campoFinal.key) {
      campoFinal.key = slugifyCampoKey(campoFinal.etiqueta, [...keysExistentes]);
    }

    const secciones = this.state.secciones.map((seccion, index) => {
      if (index !== this.state.seccionIndexActiva) return seccion;
      if (esNuevo) {
        return { ...seccion, campos: [...seccion.campos, { ...campoFinal, orden: seccion.campos.length + 1 }] };
      }
      return { ...seccion, campos: seccion.campos.map((c) => (c.key === campoFinal.key ? campoFinal : c)) };
    });

    this.cerrarModalCampo();
    this.guardarSecciones(secciones);
  };

  moverCampo = (seccionIndex, campoIndex, direccion) => {
    const secciones = this.state.secciones.map((seccion, index) => {
      if (index !== seccionIndex) return seccion;
      const campos = [...seccion.campos];
      const destino = campoIndex + direccion;
      if (destino < 0 || destino >= campos.length) return seccion;
      [campos[campoIndex], campos[destino]] = [campos[destino], campos[campoIndex]];
      return { ...seccion, campos: campos.map((c, i) => ({ ...c, orden: i + 1 })) };
    });
    this.guardarSecciones(secciones);
  };

  toggleEstadoCampo = (seccionIndex, campoKey) => {
    const secciones = this.state.secciones.map((seccion, index) => {
      if (index !== seccionIndex) return seccion;
      return {
        ...seccion,
        campos: seccion.campos.map((c) => (c.key === campoKey ? { ...c, estado: c.estado === 2 ? 1 : 2 } : c)),
      };
    });
    this.guardarSecciones(secciones);
  };

  eliminarCampo = (seccionIndex, campoKey) => {
    const secciones = this.state.secciones.map((seccion, index) => {
      if (index !== seccionIndex) return seccion;
      return { ...seccion, campos: seccion.campos.filter((c) => c.key !== campoKey) };
    });
    this.guardarSecciones(secciones);
  };

  restablecerConfiguracion = () => {
    this.setState({ loadingCampos: true });
    axios
      .post("configuracionCamposOrdenProduccionPU/restablecerConfiguracion", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
      .then((res) => {
        this.setState({ loadingCampos: false });
        if (res.data.success === 2) {
          this.setState({ secciones: res.data.configuracion.secciones || [] });
          message.success("Configuración restablecida a la plantilla base");
        } else {
          MensajeError({ message: res.data.error || "No se pudo restablecer la configuración" });
        }
      })
      .catch(() => {
        this.setState({ loadingCampos: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  renderTabCampos() {
    const { permisoConfigurarCampos } = this.props;
    return (
      <>
        {permisoConfigurarCampos && (
          <Row gutter={8} style={{ marginBottom: 16 }}>
            <Col span={8}>
              <InputItem
                placeholder="Nombre de la nueva sección"
                value={this.state.nuevaSeccionNombre}
                onChange={(e) => this.setState({ nuevaSeccionNombre: e.target.value })}
              />
            </Col>
            <Col>
              <ButtonItem icon={<PlusOutlined />} onClick={this.agregarSeccion}>
                Agregar sección
              </ButtonItem>
            </Col>
            <Col flex="auto" />
            <Col>
              <Popconfirm
                title="¿Restablecer todos los campos a la plantilla base? Se pierde cualquier campo personalizado que hayas agregado."
                onConfirm={this.restablecerConfiguracion}
              >
                <ButtonItem naranja icon={<StopOutlined />}>
                  Restablecer a la plantilla base
                </ButtonItem>
              </Popconfirm>
            </Col>
          </Row>
        )}

        <Row gutter={[16, 16]}>
          {this.state.secciones.map((seccion, seccionIndex) => (
            <DynamicCardForm
              key={seccion.nombre}
              title={seccion.nombre}
              span={24}
              collapsable
              defaultOpen
              headerRight={
                permisoConfigurarCampos && (
                  <ButtonItem size="small" icon={<PlusOutlined />} onClick={() => this.abrirModalCampo(seccionIndex)}>
                    Agregar campo
                  </ButtonItem>
                )
              }
            >
              {seccion.campos.map((campo, campoIndex) => (
                <Row key={campo.key} align="middle" gutter={8} style={{ padding: "4px 0", borderBottom: "1px solid #f0f0f0" }}>
                  <Col span={6}>{campo.etiqueta}</Col>
                  <Col span={6}>
                    {campo.tipo === "referencia" ? (
                      <>
                        <Tag color="geekblue">{etiquetaDe(ENTIDADES_REFERENCIA, campo.entidadReferencia)}</Tag>
                        <Tooltip title={`Al llenar la orden, se va a poder elegir de tu catálogo de ${etiquetaDe(ENTIDADES_REFERENCIA, campo.entidadReferencia)} ya existente en el sistema (no se escribe a mano).`}>
                          <InfoCircleOutlined style={{ color: "#999" }} />
                        </Tooltip>
                      </>
                    ) : (
                      <Tag>{etiquetaDe(TIPOS_CAMPO, campo.tipo)}</Tag>
                    )}
                  </Col>
                  <Col span={3}>{campo.obligatorio && <Tag color="orange">Obligatorio</Tag>}</Col>
                  <Col span={2}>
                    <Tooltip
                      title={
                        campo.origen === "sistema"
                          ? "Campo sugerido de base: no se puede eliminar, solo desactivar."
                          : "Campo agregado por esta empresa: se puede editar o eliminar."
                      }
                    >
                      <Tag color={campo.origen === "sistema" ? "blue" : "default"}>{campo.origen === "sistema" ? "sugerido" : "personalizado"}</Tag>
                    </Tooltip>
                  </Col>
                  <Col span={1}>{campo.estado === 2 && <Tag color="red">Inactivo</Tag>}</Col>
                  {permisoConfigurarCampos && (
                    <Col span={6} style={{ textAlign: "right" }}>
                      <Tooltip title="Subir">
                        <ButtonItem type="default" size="small" blanco icon={<ArrowUpOutlined />} onClick={() => this.moverCampo(seccionIndex, campoIndex, -1)} />
                      </Tooltip>{" "}
                      <Tooltip title="Bajar">
                        <ButtonItem type="default" size="small" blanco icon={<ArrowDownOutlined />} onClick={() => this.moverCampo(seccionIndex, campoIndex, 1)} />
                      </Tooltip>{" "}
                      <Tooltip title="Editar">
                        <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.abrirModalCampo(seccionIndex, campo)} />
                      </Tooltip>{" "}
                      {campo.estado === 2 ? (
                        <Tooltip title="Activar">
                          <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} onClick={() => this.toggleEstadoCampo(seccionIndex, campo.key)} />
                        </Tooltip>
                      ) : (
                        <Tooltip title="Desactivar">
                          <ButtonItem type="default" size="small" naranja icon={<StopOutlined />} onClick={() => this.toggleEstadoCampo(seccionIndex, campo.key)} />
                        </Tooltip>
                      )}{" "}
                      {campo.origen === "personalizado" ? (
                        <Popconfirm title="¿Eliminar este campo?" onConfirm={() => this.eliminarCampo(seccionIndex, campo.key)}>
                          <Tooltip title="Eliminar">
                            <ButtonItem type="default" size="small" rojo icon={<DeleteOutlined />} />
                          </Tooltip>
                        </Popconfirm>
                      ) : (
                        <Tooltip title="Los campos sugeridos no se pueden eliminar, solo desactivar">
                          <ButtonItem type="default" size="small" disabled icon={<DeleteOutlined />} />
                        </Tooltip>
                      )}
                    </Col>
                  )}
                </Row>
              ))}
            </DynamicCardForm>
          ))}
        </Row>

        <ModalCampoOrdenProduccionPU
          visible={this.state.modalCampoVisible}
          campo={this.state.campoActivo}
          onCancelar={this.cerrarModalCampo}
          onGuardar={this.guardarCampo}
        />
      </>
    );
  }

  render() {
    return (
      <>
        <PageHeader
          title="Campos y flujos de Órdenes de Producción"
          style={{ border: "1px solid rgb(235, 237, 240)", backgroundColor: "white", marginBottom: 10 }}
          extra={[<BotonAyudaManuales key="manuales" modulo="configuracionOrdenesProduccionPU" />]}
        />
        <div style={{ backgroundColor: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0, 0, 0, 0.06)" }}>
          <TabbedDynamicTable
            defaultActiveKey="campos"
            tabs={[
              { key: "campos", label: "Campos", customContent: this.renderTabCampos() },
              {
                key: "flujos",
                label: "Flujos de producción",
                customContent: <FlujosProduccionPU />,
              },
              {
                key: "tiemposMuertos",
                label: "Tiempos muertos",
                customContent: <CodigosTiempoMuertoPU permisoConfigurar={this.props.permisoConfigurarCampos} />,
              },
            ]}
          />
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  permisoConfigurarCampos:
    state.user.tipo === 0 ||
    !!state.user.permisos.find((v) => v.permisoId.toString() === "6a9b30eae58adfd453df660e")?.activado,
});

export default connect(mapStateToProps)(ConfiguracionOrdenesDeProduccionPU);
